// Slice 40 — text/password input with optional leading icon + error/hint.

import type { CSSProperties, InputHTMLAttributes } from "react";
import type { IconComponent } from "./HqButton";

export interface HqInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "size"> {
  leadingIcon?: IconComponent;
  trailingIcon?: IconComponent;
  mono?: boolean;
  size?: "sm" | "md" | "lg";
  hint?: string;
  error?: string;
  containerStyle?: CSSProperties;
}

const HEIGHTS = { sm: 30, md: 34, lg: 40 } as const;

export function HqInput({
  leadingIcon: L,
  trailingIcon: R,
  mono,
  size = "md",
  hint,
  error,
  containerStyle,
  style,
  ...rest
}: HqInputProps) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4, ...containerStyle }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          height: HEIGHTS[size],
          padding: "0 12px",
          background: "var(--hq-bg-input)",
          border: `1px solid ${error ? "var(--hq-danger)" : "var(--hq-border-input)"}`,
          borderRadius: "var(--hq-radius-lg)",
          transition: "border-color .12s",
        }}
      >
        {L && <L width={13} height={13} style={{ color: "var(--hq-text-dim)" }} />}
        <input
          {...rest}
          style={{
            flex: 1,
            background: "transparent",
            outline: "none",
            border: "none",
            color: "var(--hq-text)",
            fontSize: 12.5,
            fontFamily: mono ? "var(--hq-font-mono)" : "var(--hq-font-sans)",
            minWidth: 0,
            ...style,
          }}
        />
        {R && <R width={13} height={13} style={{ color: "var(--hq-text-dim)" }} />}
      </div>
      {(hint || error) && (
        <span
          style={{
            fontSize: 11,
            color: error ? "var(--hq-danger)" : "var(--hq-text-dim)",
          }}
        >
          {error || hint}
        </span>
      )}
    </div>
  );
}
